<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZdZ5tK/tc-custom/9781488061530.jpg?1726519015569" alt="This image is the cover for the book Christmas Protection Detail"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Christmas Protection Detail
      </h1>
      <p class="bookDescription body article font2">
        <b>A couple must keep an orphaned baby safe from child traffickers in this inspirational romantic suspense.</b><br/><br/>When a call from a friend in trouble leads Nick Delaney and Deputy Kaitlyn Lanz to a car crash that killed a single mother, they become the baby’s protectors. Now figuring out why someone is after the child is the only way to save her. But they must find answers soon . . . or this baby’s first Christmas might just be Nick’s and Kaitlyn’s last.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Terri Reed
      </h2>
      
      <p class="authorDescription body article">Award winning, multipublished author Terri Reed writes heart-warming romance and heart-pounding suspense. Her books have appeared on Publisher&#39;s Weekly top ten, Nielsen&#39;s Bookscan top fifty, Amazon Bestseller and featured in USA Today.&#160; You can visit her online at www.terrireed.com or email her at terrireed@sterling.net&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7eb3fed2